import React from "react";
import RoleForm from '../roles-management/RoleForm';

const EditRoles = ({ roleData }) => <RoleForm roleData={roleData} />;

export default EditRoles;
